import React, {useState} from "react";
import {StyledStepFiveExecutorAdmission} from "./index.styles";
import {Alert, Button, Col, Collapse, Input, Row, Select, Typography, Image, Skeleton} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../../../../store/selector";
import {useTranslation} from "react-i18next";
import countries from '../../../../../../assets/static/countries.json'
import {ItemMarks} from "../../ItemMarks";
import {AdmissionTableContent} from "../../AdmissionTableContent";

import iconDownload from "../../../../../../assets/icons/page/entrant/admission/icon_download.svg"

const {Panel} = Collapse;
const {Option} = Select;

export const FifthStep = ({educationOrder, title, isNeedTitle = true, extraContent = null}:any) => {

  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps'])
  const dispatch = useDispatch()

  const {admission: {provinces}} = useSelector(selectStore);

  const [visible, setVisible] = useState(false)

  const [imageUrl, setImageUrl] = useState()
  const [egovQualification, setEgovQualification]= useState()

  const getLabel = (type:any, value:any) => {

    const declarant_status = {
      '1': `${t('executorAdmissionSteps:stepTwo.typeOfPerson.citizen')}`,
      '2': `${t('executorAdmissionSteps:stepTwo.typeOfPerson.candace')}`,
      '3': `${t('executorAdmissionSteps:stepTwo.typeOfPerson.foreigner')}`,
      '4': `${t('executorAdmissionSteps:stepTwo.typeOfPerson.refuge')}`,
      '5': `${t('executorAdmissionSteps:stepTwo.typeOfPerson.asylumSeeker')}`,
      '6': `${t('executorAdmissionSteps:stepTwo.typeOfPerson.withoutCitizenship')}`,
    }

    const base_education = {
      '1': `${t('admissionView:stepsTitle.stepOne.caption.basicMiddle')}`,
      '2': `${t('admissionView:stepsTitle.stepOne.caption.generalMiddle')}`,
      '3': `${t('admissionView:stepsTitle.stepOne.caption.generalHigher')}`,
      '4': `${t('admissionView:stepsTitle.stepOne.caption.tipo')}`,
    }

    const country = countries.map((item:any) => {
      if(item.value === type){
        return t(`executorAdmissionSteps:${item.label}`)
      } else {
        return false
      }
    })

    const province = provinces.data && provinces.data.map((item:any) => {
      if(item.id === parseInt(type)){
        return item.caption
      }
    })

    const district = provinces.data && provinces.data.map((item:any) => {
      if(item.id === parseInt(educationOrder.educationOrder.region)){
        return item.regions.map((reg:any) => {
          if(reg.id === parseInt(type)){
            return reg.caption
          } return false
        })
      } return false
    })

    const school = provinces.data && provinces.data.map((item:any) => {
      if(item.id === parseInt(educationOrder.educationOrder.region)){
        return item.regions.map((reg:any) => {
          if(reg.id === parseInt(educationOrder.educationOrder.district)){
            return reg.schools.map((study:any) => {
              if(study.id === parseInt(type)){
                return study.caption
              } return false
            })
          } return false
        })
      } return false
    })

    const education_form = {
      '1': `${t('executorAdmissionSteps:stepOne.eduForm.fullTime')}`,
      '2': `${t('executorAdmissionSteps:stepOne.eduForm.distant')}`,
      '3': `${t('executorAdmissionSteps:stepOne.eduForm.evening')}`,
    }

    const pay_form = {
      '1': `${t('admissionView:stepsTitle.stepOne.caption.grant')}`,
      '2': `${t('admissionView:stepsTitle.stepOne.caption.pay')}`,
    }

    const education_type = {
      '1': `${t('executorAdmissionSteps:stepOne.specialtyType.work')}`,
      '2': `${t('executorAdmissionSteps:stepOne.specialtyType.bachelor')}`,
    }

    const language_of_education = {
      '1': 'Казахский',
      '2': 'Русский',
      '3': 'Английский',
    }

    if(value === "declarant_status"){
      // @ts-ignore
      return declarant_status[type]
    } else if(value === "base_education"){
      // @ts-ignore
      return base_education[type]
    } else if(value === "country"){
      return country.every((item) => item === false) ? type : country
    } else if(value === "education_form"){
      // @ts-ignore
      return education_form[type]
    } else if(value === "pay_form"){
      // @ts-ignore
      return pay_form[type]
    } else if(value === "education_type"){
      // @ts-ignore
      return education_type[type]
    } else if(value === "language_of_education"){
      // @ts-ignore
      return language_of_education[type]
    } else if(value === "region"){
      return province
    } else if(value === "district"){
      return district
    } else if(value === "school"){
      return school
    }
  }

  const setFIO = (surname:any, name:any, patronymic:any) => {
    if(name && name !== "undefined" ){
      if(name.trim() !== '') {
        return surname + " " + name + " " + patronymic
      }
    }
  }

  const handleChangeEgovQualification = (id:any, itemId:any) => {
    // @ts-ignore
    setEgovQualification({
    // @ts-ignore
      qualification_id: id,
      id: itemId
    })
  }

  const handleSendEgovQualification = () => {
    // dispatch(changeSelectedSpecialityQualificationAction(egovQualification))
  }

  const firstTable = [
    {
      key: 1,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.iin.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.iin_entrant
    },
    {
      key: 2,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.fioEntrant')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && setFIO(educationOrder.educationOrder.surname_entrant, educationOrder.educationOrder.name_entrant, educationOrder.educationOrder.patronymic_entrant ? educationOrder.educationOrder.patronymic_entrant : '')
    },
    {
      key: 3,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.birthdayEntrant')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.birthday_entrant
    },
    {
      key: 4,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.statusEntrant')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.declarant_status, "declarant_status")
    },
    {
      key: 5,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.iinParent')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.iin_parent
    },
    {
      key: 6,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.birthdayParent')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.birthday_parent
    },
    {
      key: 7,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.fioParent')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && setFIO(educationOrder.educationOrder.parent_surname, educationOrder.educationOrder.parent_name, educationOrder.educationOrder.parent_patronymic_entrant ? educationOrder.educationOrder.parent_patronymic_entrant : '')
    },
    {
      key: 8,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.statusParent')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.parent_status
    },
  ]

  const secondTable = [
    {
      key: 7,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.basicEducation.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.base_education, "base_education")
    },
    {
      key: 8,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]:  `${t('executorAdmissionSteps:stepThree.infoAboutEducation.country')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.country, "country")
    },
    {
      key: 11,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepThree.infoAboutEducation.school')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.school
    },
    educationOrder && educationOrder.educationOrder.series_certificate && educationOrder.educationOrder.number_certificate ? (
      {
        key: 12,
        [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.seriaAndNomer')}`,
        [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.series_certificate + " " + educationOrder && educationOrder.educationOrder.number_certificate
      }) : {}
  ]

  const secondTableKz = [
    {
      key: 7,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.basicEducation.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.base_education, "base_education")
    },
    {
      key: 8,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepThree.infoAboutEducation.country')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.country, "country")
    },
    {
      key: 9,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepThree.infoAboutEducation.region')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.region, "region")
    },
    {
      key: 10,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]:`${t('executorAdmissionSteps:stepThree.infoAboutEducation.district')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.district, "district")
    },
    {
      key: 11,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepThree.infoAboutEducation.school')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.school, "school")
    },
    {
      key: 12,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.seriaAndNomer')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.series_certificate + " " + educationOrder && educationOrder.educationOrder.number_certificate
    },
  ]

  const thirdTable = [
    {
      key: 13,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.address.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.declarant_address
    },
    {
      key: 14,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.phoneNumber.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.phone_entrant
    },
    {
      key: 15,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.email.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.email_entrant
    },
  ]

  const hostelSection = [
    {
      key: 40,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.hostel.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.hostel && educationOrder && educationOrder.educationOrder.hostel === "1" && "Да"
    },
  ]

  const fourthTable = [
    {
      key: 16,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.invalidChild.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.child_invalid && educationOrder && educationOrder.educationOrder.child_invalid === "1" && "Да"
    },
    {
      key: 17,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.quota && educationOrder && educationOrder.educationOrder.quota === "1" && "Да"
    },

    {
      key: 30,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.invalid1and2')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.invalid1and2 && educationOrder.educationOrder.invalid1and2 === "1" && "Да"
    },
    {
      key: 31,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.vov')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.vov && educationOrder.educationOrder.vov === "1" && "Да"
    },
    {
      key: 32,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.village_soc_ek')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.village_soc_ek && educationOrder.educationOrder.village_soc_ek === "1" && "Да"
    },
    {
      key: 33,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.faces_kaz_nac_without_rk')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.faces_kaz_nac_without_rk && educationOrder.educationOrder.faces_kaz_nac_without_rk === "1" && "Да"
    },
    {
      key: 34,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.children_without_parent')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.children_without_parent && educationOrder.educationOrder.children_without_parent === "1" && "Да"
    },
    {
      key: 35,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.village_rk')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.village_rk && educationOrder.educationOrder.village_rk === "1" && "Да"
    },
    {
      key: 36,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.children_many')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.children_many && educationOrder.educationOrder.children_many === "1" && "Да"
    },
    {
      key: 37,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.family_half')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.family_half && educationOrder.educationOrder.family_half === "1" && "Да"
    },
    {
      key: 37,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]:  `${t('executorAdmissionSteps:stepTwo.quota.listOfQuotes.family_with_invalid')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.family_with_invalid && educationOrder.educationOrder.family_with_invalid === "1" && "Да"
    },

    {
      key: 18,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.enbek.label1')} ${t('executorAdmissionSteps:stepTwo.enbek.label2')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.enbek && educationOrder.educationOrder.enbek === "1" && "Да"
    },
    {
      key: 38,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepTwo.asp.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && educationOrder.educationOrder.social_help && educationOrder.educationOrder.social_help === "1" && "Да"
    },
  ]

  const fifthTable = [
    {
      key: 21,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepOne.eduForm.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.education_form, "education_form")
    },
    {
      key: 22,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepOne.payForm.label')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.pay_form, "pay_form")
    },
    {
      key: 23,
      [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('admissionView:stepsTitle.stepOne.caption.tipPodgotovki')}`,
      [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: educationOrder && getLabel(educationOrder.educationOrder.education_type, "education_type")
    },
  ]

  const specialities = () => {
    let arr = [] as any
    let selectedSpecialities = [] as any

    if(educationOrder && educationOrder.educationOrder && Array.isArray(educationOrder.educationOrder.selectedSpecialities)){
      selectedSpecialities = [...educationOrder.educationOrder.selectedSpecialities]

      selectedSpecialities.sort((a:any,b:any) => a.priority - b.priority)
    }

    selectedSpecialities = selectedSpecialities.map((item:any, index:any) => {

      return item.qualification ? (
        [
          {
            key: index === 0 ? parseInt(`1${item.id}`) : item.id + item.speciality.caption,
            [t('executorAdmissionSteps:admissionForm.fieldsName')]: index === 0 ? `${t('executorAdmissionSteps:admissionForm.specialtyName')} ${index + 1} (${t('executorAdmissionSteps:admissionForm.priority')})` : `${t('executorAdmissionSteps:admissionForm.specialtyName')} ${index + 1}`,
            [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: item.speciality.caption,
            "specialities": true
          },
          {
            key: index === 1 ? parseInt(`2${item.id}`) : item.id + item.language_of_education,
            [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepOne.specialtyForm.language')}`,
            [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: getLabel(item.language_of_education, "language_of_education"),
          },
          {
            key: index === 2  ? parseInt(`3${item.id}`) : item.id + item.qualification.caption,
            [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepOne.specialtyForm.qualification')}`,
            [t('executorAdmissionSteps:admissionForm.dataFromApplication')] : item.qualification.caption,
          },
          {
            key: index === 3 ? parseInt(`4${item.id}`) : item.id + item.college.name,
            [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:admissionForm.collegeName')}`,
            [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: item.college.name,
          }
        ]
      ) : (
        [
          {
            key: index === 0 ? parseInt(`1${item.id}`) : item.id + item.speciality.caption,
            [t('executorAdmissionSteps:admissionForm.fieldsName')]: index === 0 ? `${t('executorAdmissionSteps:admissionForm.specialtyName')} ${index + 1} (${t('executorAdmissionSteps:admissionForm.priority')})` : `${t('executorAdmissionSteps:admissionForm.specialtyName')} ${index + 1}`,
            [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: item.speciality.caption,
            "specialities": true
          },
          item.language_of_education ?
            {
              key: index === 1 ? parseInt(`2${item.id}`) : item.id + item.language_of_education,
              [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepOne.specialtyForm.language')}`,
              [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: getLabel(item.language_of_education, "language_of_education"),
            } : {
              key: `empty_language_${item.id}`,
              [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepOne.specialtyForm.language')}`,
              [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: `${t('executorAdmissionSteps:admissionForm.languageIsUndefined')}`,
            },
          {
            key: index === 2  ? parseInt(`3${item.id}`) : item.id + "caption",
            [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:stepOne.specialtyForm.qualification')}`,
            [t('executorAdmissionSteps:admissionForm.dataFromApplication')] : (
              <Row justify="space-between">
                <Select disabled={(educationOrder && educationOrder?.educationOrder?.current_college_id != item.college_id)} size="large" style={{width: '80%'}} onChange={(value) => handleChangeEgovQualification(value, item.id)}>
                  {item.availableQualifications.map((qualification:any) => (
                    <Option value={qualification.id}>{qualification.caption}</Option>
                  ))}
                </Select>
                <Button className="admission__button admission__button--item"
                              disabled={!egovQualification}
                              onClick={() => handleSendEgovQualification()}>
                  {t('executorAdmissionSteps:admissionForm.submit')}
                </Button>
              </Row>
            ),
          },
          {
            key: index === 3 ? parseInt(`4${item.id}`) : item.id + item.college.name,
            [t('executorAdmissionSteps:admissionForm.fieldsName')]: `${t('executorAdmissionSteps:admissionForm.collegeName')}`,
            [t('executorAdmissionSteps:admissionForm.dataFromApplication')]: item.college.name,
          }
        ]
      )
    })


    selectedSpecialities.map((item:any) => item.map((item:any) =>
      arr.push(item)
    ))

    return arr
  }

  const checkValue = (arr:any) => {
    let array
    let filtered

    if (arr !== fifthTable) {
      filtered = [...arr]
    } else {
      filtered = [...arr, ...specialities()]
    }

    array = filtered.filter(item => {
      // @ts-ignore
      if (item[[t('executorAdmissionSteps:admissionForm.dataFromApplication')]]) {
        return true
      }
    })

    return array
  }

  const imagePreview = (src:any) => {

    if (src.includes('.pdf')) {
      window.open(src, '_black')
    } else {

      setVisible(true)

      setImageUrl(src)
    }
  }

  const collapseItems = [
    {
      key: "1",
      label: <div className="admission__middle-mark">
        {t('admissionView:stepsTitle.stepOne.caption.averageDiplom')}:
        <span>{educationOrder && educationOrder.educationOrder.average}</span>
      </div>,
      children: <div>

        <ItemMarks
            headerTitle={t('executorAdmissionSteps:admissionForm.seventhSection')}
            footerVisible={false}
            data={educationOrder && educationOrder.educationOrder.markList.common}
            disabledInput={true}
            span={8}
        />


        {/*  <Row>*/}
        {/*    <Col span={24}>*/}
        {/*      <Row justify="space-between" gutter={[16, 16]}>*/}
        {/*        {educationOrder && educationOrder.educationOrder.markList.selectedSpeciality.map(item => (*/}
        {/*            item.profileMarks.length > 0 &&*/}
        {/*            <Col span={12} key={item.id}>*/}
        {/*              {item.qualification ? null :*/}
        {/*                  <ItemMarks*/}
        {/*                      headerTitle={item.qualification.code + ' - ' + item.qualification.caption}*/}
        {/*                      footerVisible={false}*/}
        {/*                      data={item.profileMarks}*/}
        {/*                      disabledInput={true}*/}
        {/*                      span={8}*/}
        {/*                  />*/}
        {/*              }*/}
        {/*            </Col>*/}
        {/*        ))}*/}


        {/*      </Row>*/}
        {/*    </Col>*/}
        {/*  </Row>*/}

        <div className="admission__content-item">
          {
            [5, 4, 3, 2].map((item, index) => (
                <Row className="marks__item" style={{marginBottom: 16}} key={item}>
                  <Col flex="46px">
                    <Input className='marks__input' disabled maxLength={2}
                           value={educationOrder && educationOrder.educationOrder && educationOrder.educationOrder.educationDocument.ratings[index].count}/>
                  </Col>
                  <Col style={{marginLeft: 16}}>
                    <Typography.Text style={{marginLeft: 0}}>{t('admissionView:countInEducationDocument', {item: item})}</Typography.Text>
                  </Col>
                </Row>
            ))
          }

          <Row gutter={16}>
            <Col>
              <Alert
                  message={<span>{t('admissionView:totalAvgSubject')} <strong style={{marginLeft: 16}}>{educationOrder && educationOrder.educationOrder && educationOrder.educationOrder.educationDocument.count}</strong></span>}
                  type="success"
              />
            </Col>

            <Col>
              <Alert
                  message={<span>{t('admissionView:totalAvgRating')} <strong style={{marginLeft: 16}}>{educationOrder && educationOrder.educationOrder && educationOrder.educationOrder.educationDocument.avg_rating}</strong></span>}
                  type="warning"
              />
            </Col>
          </Row>
        </div>

      </div>
    }
  ]

  return(
    <StyledStepFiveExecutorAdmission>
      <div className="header">
        {isNeedTitle ? (
          <h2>
            {title ? title : t("admissionView:signingApplication")}
          </h2>
        ) : null}
      </div>

      {
        extraContent ? (
          extraContent
        ) : null
      }

      <div className="body">
        <Skeleton loading={!educationOrder}>
          <AdmissionTableContent
            title={t('executorAdmissionSteps:admissionForm.firstSection')}

            columns={[
              {
                title: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                key: 'Название полей',
                width: "50%"
              },
              {
                title: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                key: 'Данные с заявления',
                width: "50%"
              },
            ]}

            data={checkValue(firstTable)}
          />

          <AdmissionTableContent
            title={t('executorAdmissionSteps:stepTwo.basicEducation.label')}

            columns={[
              {
                title: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                key: 'Название полей',
                width: "50%"
              },
              {
                title: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                key: 'Данные с заявления',
                width: "50%"
              },
            ]}

            data={(educationOrder && (educationOrder.educationOrder.region === "undefined" || "")) ? checkValue(secondTableKz) : checkValue(secondTable)}
          />

          <AdmissionTableContent
            title={t('executorAdmissionSteps:admissionForm.thirdSection')}

            columns={[
              {
                title: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                key: 'Название полей',
                width: "50%"
              },
              {
                title: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                key: 'Данные с заявления',
                width: "50%"
              },
            ]}

            data={checkValue(thirdTable)}
          />

          <AdmissionTableContent
            title={t('executorAdmissionSteps:admissionForm.hostelSection')}

            columns={[
              {
                title: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                key: 'Название полей',
                width: "50%"
              },
              {
                title: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                key: 'Данные с заявления',
                width: "50%"
              },
            ]}

            data={checkValue(hostelSection)}
          />

          <AdmissionTableContent
            title={t('executorAdmissionSteps:admissionForm.fourthSection')}

            columns={[
              {
                title: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                key: 'Название полей',
                width: "50%"
              },
              {
                title: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                key: 'Данные с заявления',
                width: "50%"
              },
            ]}

            data={checkValue(fourthTable)}
          />

          <AdmissionTableContent
            title={t('executorAdmissionSteps:admissionForm.fifthSection')}

            columns={[
              {
                title: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.fieldsName')}`,
                key: 'Название полей',
                width: "50%"
              },
              {
                title: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                dataIndex: `${t('executorAdmissionSteps:admissionForm.dataFromApplication')}`,
                key: 'Данные с заявления',
                width: "50%"
              },
            ]}

            data={checkValue(fifthTable)}
          />

          <div className="admission__content-item">
            <h3 className="admission__subtitle">{t('admissionView:stepsTitle.stepOne.caption.pinDocument')}</h3>

            {educationOrder && educationOrder.educationOrder.source === '1' ? (
              educationOrder && educationOrder.educationOrder.docs.map((item:any) => (
                <Row key={item.id}>
                  <Col span={12}>{item.name}</Col>
                  <Col span={12}>
                    <Button
                      type="link"
                      className="admission__download"
                      onClick={() => imagePreview(item.url)}
                    >
                      <Image
                        src={iconDownload}
                        preview={false}
                      />
                      {item.url.split('/')[item.url.split('/').length - 1]}
                    </Button>
                  </Col>
                </Row>
              ))
            ) : (
              educationOrder && educationOrder.educationOrder.docs.map((item:any) => (
                <Row key={item.id}>
                  <Col span={12}>{t(`executorAdmissionSteps:${item.name.split(".").slice(0, -1).join(".")}`)}</Col>
                  <Col span={12}>
                    <Button
                      type="link"
                      className="admission__download"
                      onClick={() => imagePreview(item.url)}
                    >
                      <Image
                        src={iconDownload}
                        preview={false}
                      />
                      {item.url.split('/')[item.url.split('/').length - 1]}
                    </Button>
                  </Col>
                </Row>
              ))
            )
            }

          </div>

{/*          {educationOrder && educationOrder.educationOrder.markList.common.length !== 0 ? (*/}
{/*            educationOrder && educationOrder.educationOrder.source !== '1' ? (*/}
{/*              <div className="admission__content-item">*/}

{/*                <h3 className="admission__subtitle">{t('executorAdmissionSteps:admissionForm.seventhSection')}</h3>*/}

{/*/!*@ts-ignore*!/*/}
{/*                <Collapse accordion expandIconPosition='end' items={collapseItems}/>*/}


{/*              </div>*/}
{/*            ) : null*/}

{/*          ) : null}*/}

          <Image
            width={200}
            style={{display: 'none'}}
            src={imageUrl}
            preview={{
              visible,
              onVisibleChange: value => {
                setVisible(value);
              },
            }}
          />

        </Skeleton>
      </div>
    </StyledStepFiveExecutorAdmission>
)
}